import {emitter, EVENTS} from '../emitter';

export class Wheel {
  public scrollAllowed: boolean = true;
  public scrollSpeed: number = 1;
  public acceleratingThreshold: number = 10;
  public accelerating: boolean = false;

  private lastDelta: number = 0;

  constructor() {
    window.addEventListener('wheel', this.onWheel, true);
    window.addEventListener('keydown', this.onKeydown, true);
  }

  private onKeydown = (event: KeyboardEvent) => {
    if (event.which === 32) {
      emitter.emit(EVENTS.scroll, {direction: 1, delta: 40});
    }

    if (event.which === 40) {
      emitter.emit(EVENTS.scroll, {direction: 1, delta: 20});
    }

    if (event.which === 38) {
      emitter.emit(EVENTS.scroll, {direction: -1, delta: -20});
    }
  };

  private onWheel = (event: any) => {
    //Todo: check cross brwoser for this delta.
    let delta = -event.deltaY;

    this.accelerating = Math.abs(this.lastDelta - delta) > this.acceleratingThreshold ? true : false;
    this.lastDelta = delta;

    if (this.scrollAllowed) {
      emitter.emit(EVENTS.wheel, {
        direction: Math.sign(delta),
        delta: -delta * this.scrollSpeed,
        accelerating: this.accelerating
      });
    }
  };
}
